import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import * as moment from 'moment';
import {NbFieldType} from './nbinput.entity';

@Component({
    selector: 'nbinput-date',
    template: require('./nbinput-date.component.html'),
    styles: [require('./nbinput-date.component.scss')],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => NbinputDateComponent),
            multi: true
        }
    ]
})

export class NbinputDateComponent implements ControlValueAccessor {
    public FieldType = NbFieldType;
    config: any = {
        format: 'YYYY-MM-DD',
        monthFormat: 'YYYY-MM',
        timeFormat: 'HH:mm:ss',
        datetimeFormat: 'YYYY-MM-DDTHH:mm:ss',
        showMultipleYearsNavigation: true,
        locale: moment.locale('zh-cn'),
    };

    calType = {
        'date': 'day',
        'datetime': 'daytime',
        'time': 'time',
        'month': 'month',
    };
    formats = {
        date: 'YYYY-MM-DD',
        month: 'YYYY-MM',
        time: 'HH:mm:ss',
        datetime: 'YYYY-MM-DD HH:mm:ss'
    };

    private onTouchedCallback = () => {};
    private onChangeCallback = (_) => {};


    @Input()
    public format;
    getFormat() {
        if (this.format && (typeof this.format == 'string') && this.format.trim().length > 0) {
            return this.format.trim();
        }
        switch (this._type) {
            case NbFieldType.Datetime: {
                return 'yyyy-MM-dd HH:mm:ss';
            }
            case NbFieldType.Date: {
                return 'yyyy-MM-dd';
            }
            case NbFieldType.Time: {
                return 'HH:mm:ss';
            }
            case NbFieldType.Month: {
                return 'yyyy-MM';
            }
        }
    }
    public _raw = null;
    public _data = null;
    @Input()
    set data(val) {
        if (val) {
            const obj = moment(val);
            if (obj.isValid()) {
                this._data = obj.format(this.formats[this.type]);
                this._raw = obj;
                return;
            }
        }
        this._raw = null;
        this._data = null;
    }
    get data() {
        return this._raw && (typeof this._raw.format == 'function') ? this._raw.format(this.outFormat) : null;
    }
    @Input()
    public disabled;

    get value(): any {
        return this.data;
    };
    set value(v: any) {
        this.data = v;
        if (this._data != v) {
            this.onChangeCallback(this.data);
        }
    }

    onBlur() {
        this.onTouchedCallback();
    }

    @Input()
    public placeholder = '点击选择时间';

    public _type: NbFieldType = NbFieldType.Date;
    @Input()
    set type(tp: NbFieldType) {
        this._type = tp;
        switch (tp) {
            case NbFieldType.Time: {
                this.config = {
                    format: 'HH:mm:ss',
                    locale: moment.locale('zh-cn'),
                };
                break;
            }
            case NbFieldType.Month: {
                this.config = {
                    format: 'YYYY-MM',
                    showMultipleYearsNavigation: true,
                    locale: moment.locale('zh-cn'),
                };
                break;
            }
            case NbFieldType.Datetime: {
                this.config = {
                    format: 'YYYY-MM-DD HH:mm:ss',
                    showMultipleYearsNavigation: true,
                    locale: moment.locale('zh-cn'),
                };
                break;
            }
            default:
                this.config = {
                    format: 'YYYY-MM-DD',
                    showMultipleYearsNavigation: true,
                    locale: moment.locale('zh-cn'),
                };
        }
    }
    get type() {
        return this._type;
    }

    @Input()
    public readonly = false;

    private outFormat = 'YYYY-MM-DDTHH:mm:ss.SSSZ';
    // private outFormat = null;

    registerOnChange(fn: any): void {this.onChangeCallback = fn; }
    registerOnTouched(fn: any): void {this.onTouchedCallback = fn; }
    setDisabledState?(isDisabled: boolean): void { this.disabled = isDisabled; }
    writeValue(obj): void {
        this.data = obj;
    }
    changed(evt) {
        if (evt) {
            // this.data = this.setDateFormat(evt);
            this._raw = evt;
            this.onChange.emit(evt.format(this.outFormat));
            this.onChangeCallback(evt.format(this.outFormat));
        } else {
            this._raw = null;
            this.onChange.emit(null);
            this.onChangeCallback(null);
        }
    }
    @Output() public onChange: EventEmitter<any> = new EventEmitter();

}

